export default __webpack_public_path__ + "static/media/ht.bbbd7c26.svg";